/** Addresses of the family app's office pages (kept apart so links don't load the pages). */
export const BULK_INVITE_PATH = "/students/invite";
export const SLIPS_PATH = "/students/invite/slips";
export const FAMILY_CHECKS_PATH = "/students/family-checks";
